// extracted by mini-css-extract-plugin
export default {"wrapper":"VerifyYourIdentityPage-module__wrapper-yolr","content":"VerifyYourIdentityPage-module__content-jae0","loader":"VerifyYourIdentityPage-module__loader-wWMr"};